module.exports = __webpack_public_path__ + "static/media/image11.d744afbf.png";